var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"review-view-header"},[_c('ExitReviewButton'),_vm._v(" "),_c('ViewOptions',{staticClass:"review-view-header__view-options",attrs:{"icon-size":'large',"view-id":_vm.viewId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }